module.exports = __webpack_public_path__ + "img/back_32.54e87915.svg";